var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "account" } },
    [
      _c(
        "div",
        { staticClass: "logo__container", attrs: { "no-gutters": "" } },
        [
          _c("img", {
            staticClass: "logo__image",
            attrs: {
              src: "/static/images/header/cwa-logo.png",
              alt: "客製化版本logo"
            }
          }),
          _vm._v(" "),
          _vm._m(0)
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "about_treeview" },
        [
          _vm.init_items.length > 0
            ? _c("TreeView", {
                attrs: {
                  init_items: _vm.init_items,
                  checked_selectors: _vm.checked_selectors,
                  init_opened_layers: _vm.init_opened_layers,
                  check_function: _vm.change_about_type
                }
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "v-row",
            {
              staticClass: "info__container",
              attrs: { justify: "space-between" }
            },
            [
              _c("v-col", { attrs: { cols: "12" } }, [
                _vm.is_en
                  ? _c("span", [
                      _c(
                        "a",
                        {
                          staticClass:
                            "info__main-title info__main-title--english info__link",
                          attrs: {
                            href: "https://www.cwa.gov.tw/eng/",
                            target: "_blank"
                          }
                        },
                        [
                          _c("span", [
                            _vm._v(
                              "\n                            Central Weather Administration Copyright Reserved\n                        "
                            )
                          ]),
                          _vm._v(" "),
                          _c("span", [
                            _vm._v(
                              "\n                            Reference time: TST "
                            ),
                            _c("br"),
                            _vm._v(
                              "\n                            (Taiwan Standard Time; GMT + 08:00) \n                        "
                            )
                          ])
                        ]
                      )
                    ])
                  : _c("span", [
                      _c(
                        "a",
                        {
                          staticClass: "info__main-title info__link",
                          attrs: {
                            href: "http://www.cwa.gov.tw/",
                            target: "_blank"
                          }
                        },
                        [
                          _vm._v(
                            "\n                        " +
                              _vm._s(_vm.$t("__footer.offcial_web_link")) +
                              "\n                    "
                          )
                        ]
                      )
                    ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "info__content" }, [
                  _vm._v(_vm._s(_vm.$t("__footer.telephone")))
                ]),
                _vm._v(" "),
                _c("br"),
                _vm._v(" "),
                _c("span", { staticClass: "infO__content" }, [
                  _vm._v(_vm._s(_vm.$t("__footer.address")))
                ])
              ])
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "900px", "min-height": "328px" },
          model: {
            value: _vm.show_about_dialog,
            callback: function($$v) {
              _vm.show_about_dialog = $$v
            },
            expression: "show_about_dialog"
          }
        },
        [
          _c("div", { staticClass: "about-dialog" }, [
            _c(
              "div",
              { staticClass: "header" },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(_vm.current_about.name) +
                    "\n                "
                ),
                _c(
                  "v-icon",
                  {
                    staticClass: "close-btn",
                    attrs: { color: "white" },
                    on: {
                      click: function($event) {
                        _vm.show_about_dialog = false
                      }
                    }
                  },
                  [_vm._v("\n                    icon-close\n                ")]
                )
              ],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "about-card" }, [
              _vm.current_about.id === "qplus_1"
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.is_en
                        ? [
                            _c("p", [
                              _vm._v(
                                "\n                            In 2001, CWA began to work with the National Severe Storms Laboratory of the US and several government agencies in Taiwan to develop QPESUMS, to provide real-time weather information for the purpose of emergency response procedure for disasters caused by severe weather.\n                            As each agency needs the specific weather information related to its task, since 2011, CWA has provided via QPESUMS customized meteorological and marine information for hazard prevention to suit the operational needs of air, land and marine transportations, hydraulic engineering and water conservation, etc.\n                            The government agencies that receive and make use of such information include Directorate General of Highways), Water Resource Agency, and Agency of Rural Development and Soil and Water Conservation. In 2019, a new customized system called QPlus replaced QPESUMS and began operation.\n                        "
                              )
                            ])
                          ]
                        : [
                            _c("p", [
                              _vm._v(
                                "\n                            為強化氣海象資訊於防災作業的應用，中央氣象署自民國100年始推展劇烈天氣監測系統(QPESUMS)防災客製化服務，運用臺灣及鄰近海域各式氣海象資訊，針對易發生坍方、土石流、淹水等現象的轄管區域，開發符合各業管機關防救災作業需求的客製化功能與產品，供各級政府及機關執行防救減災行動作為參考依據。QPESUMS防災客製化服務初期應用於陸海空交通運輸領域，持續拓展至水土保持、水利工程、救災(難)及國防氣象等，亦延伸至配合地方政府防災作業。\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            隨著網際網路瀏覽器使用趨勢的改變，為延續並深化QPESUMS對政府機關的防災資訊服務，氣象署近年來著手開發結合地理資訊系統(GIS)的"
                              ),
                              _c("b", [_vm._v(_vm._s(_vm.web_name))]),
                              _vm._v(
                                "，其可跨瀏覽器使用，並承接上游QPESUMS系統產製的雷達資料與衍生產品，亦包含地面觀測、衛星雲圖、閃電資料及颱風資訊等更多元的氣象監測與預報資訊，以提升氣象資訊於防救災決策的應用效能。\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("br"),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            QPEplus除提供政府防災單位防災資訊服務外，民國108年亦推出「民眾版劇烈天氣監測系統QPlus」，以方便的操作功能提供民眾查詢即時氣象資訊，推動個人化的防災服務，便利生活也保障民眾安全。\n                        "
                              )
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.current_about.id === "qplus_2"
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.is_en
                        ? [
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                Authorization Method & Scope：\n                                "
                                ),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    In order to facilitate the public to better utilize the website information, all of QPlus's publicly posted information and materials that are protected under copyright provisions may be reauthorized for public use without cost in a non-exclusive manner. The users are not limited to time and by region to reproduce, adapt, edit, publicly transmit or utilize with other methods, and as well as to develop various products or services (herein known as derivations). This authorization will not be retracted hereafter, and the users do not have to acquire any written or other methods of authorization from the Administration. However, when using it, the user should state the source.\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                Information on Related Items：\n                                "
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        The authorized scope is only within the scope protected under copyright. It does not include other intellectual property rights, including but not limited to the provision of patents, trademarks and administration's logo.\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        Whether or not the said person's actively publicized or legally required publicized personal information can be collected, processed or utilized, the user must follow the related provisions based on the Personal Information Protection Act, and plan to execute the related measures required by law.\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        For some videos, photos, sheet music and contracted case writings or other works, the administration must especially state that the approval must be duly obtained before use.\n                                    "
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                Should be prudential not to infringe upon a third party in moral rights in copyrights (including the rights to identify names and the rights to ban unjustifiable change.)\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                After using the information and material provided by this authorization, one should not maliciously alter its related information. If edited and the reworked information does not match the original, the user is liable for civil and criminal legal responsibilities.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                The website's authorization does not authorize the user to represent the administration's recommendation, approval or agreement with the status of the added derivatives.\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h2", { staticClass: "content__title" }, [
                              _vm._v(
                                "\n                            Links to the QPlus Website\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                The Website （qpeplus.cwa.gov.tw） is open for connection to the public. No consent of the QPlus is required, provided that the title of the QPlus shall be expressly specified.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                Names, locations, and format of the files contained in the Website may be updated or amended at any time; therefore, we do not suggest links made to certain files (such as .htm files) or via automatic retrieve means to obtain the relevant information.\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            Disclaimer\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus promises, to the best of its efforts, to assure the timeliness and accuracy of the information it provided; however, the relevant information will, at any time, be revised or updated in accordance with the then current actual situation. The QPlus is not responsible to notify anyone of such revision or updating in advance. It shall be the user's responsibility to obtain the latest information, understand the relevant meanings and applying limitations, and correctly use such information in case any misinterpretation.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                Due to the application natures of Internet, when a user visits the Website, please note if there is any proxy server provided by his internal system or ISP operators to view this Website. The QPlus may not resolve problems for users regarding those arising from the storage time of cache, preference settings or malfunction caused by such proxy server. The user shall contact the responsible unit to eliminate such barriers.\n                            "
                                )
                              ])
                            ])
                          ]
                        : [
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                授權方式及範圍：\n                                "
                                ),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    為利各界廣為利用網站資料，中央氣象署「" +
                                      _vm._s(_vm.web_name) +
                                      "」網站上刊載之所有資料與素材，其得受著作權保護之範圍，以無償、非專屬，得再授權之方式提供公眾使用，使用者得不限時間及地域，重製、改作、編輯、公開傳輸或為其他方式之利用，開發各種產品或服務（簡稱加值衍生物），此一授權行為不會嗣後撤回，使用者亦無須取得本機關之書面或其他方式授權；然使用時，應註明出處。\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                相關事項說明：\n                                "
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        本授權範圍僅及於著作權保護之範圍，不及於其他智慧財產權利，包括但不限於專利、商標、及機關標誌之提供。\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        當事人自行公開或依法令公開之個人資料是否得被蒐集、處理及利用，使用者須自行依照個人資料保護法之相關規定，規劃並執行法律要求之相應措施。\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        部分的影音、圖像、樂譜、專人專案撰文或其他著作，經機關特別聲明須經同意方可使用者。\n                                    "
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                應注意不得侵害第三人之著作人格權(包括姓名表示權及禁止不當變更權)。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                使用本授權提供之資料與素材，不得惡意變更其相關資訊，若利用後所展示之資訊與原資料與素材不符，使用者須自負民事、刑事上之法律責任。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                本網站之授權，並不授予使用者代表本機關建議、認可或贊同其加值衍生物之地位。\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h2", { staticClass: "content__title" }, [
                              _vm._v(
                                "\n                            連結至中央氣象署「" +
                                  _vm._s(_vm.web_name) +
                                  "」網站\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                任何網站可與本網站（qpeplus.cwa.gov.tw）連結，毋須經本署同意，但連結時須明白標示本署名銜及系統名稱。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                本網站上檔案之名稱、位置及內容格式會不定期更新或異動，故不建議您連結至特定檔案(如htm)或採用自動擷取方式取用相關資訊。\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            免責聲明\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                中央氣象署「" +
                                    _vm._s(_vm.web_name) +
                                    "」網站所提供之資料，本署將盡力確保其即時性及正確性，惟相關內容可能隨時依實際狀況進行異動更新或改版，本署並不負預先通知之責，使用者應自行注意取用最新之資料，與瞭解相關資訊的意義及使用限制並正確運用相關資訊，以避免不當的解讀。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                基於網際網路的應用特性，使用瀏覽器瀏覽相關資訊時，請注意是否有透過單位內部或ISP業者提供之代理伺服器（proxy server）瀏覽本網頁，若因該伺服器之快取(cache)的儲存時間、參數設定或故障等因素，導致相關資訊無法更新，影響氣象訊息的準確及時效，請自行與相關單位連絡排除問題，本署無法代為處理。\n                            "
                                )
                              ])
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.current_about.id === "qplus_3"
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.is_en
                        ? [
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            Personal Information Collection and Use\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                When you use the QPlus web site, we will automatically collect the following information: date and time, the webpage you request, URL you are on, browser type, and any action (such as downloads, etc) whether that action was successful or not. The information may help improve the efficiency of our web site.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus will monitor any action which may cause a heavy load to our web site.\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            Information Security Personnel Management and Education\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                For employees who deal with sensitive and confidential information and those who are entitled to manage systems because of job requirement, clear division of labor will be arranged in order to disperse rights and duties; and evaluation and examination systems will be established, as well as mutual support systems.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                For employees who resign (ask for leave, suspended from duties), all related security measures should follow concerned procedures and the authorization to all systems will be terminated immediately.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                Depending on positions and occupational ability of different levels of employees, education and training for information security will be conducted, in order to help them understand the importance and all possible risks, and to enhance the awareness of conforming to the relative regulations accordingly.\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            Information Security Procedures of Protection\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus will establish operation procedures for information security issues, and impose necessary responsibilities on employees concerned in order to respond to any related event promptly and efficiently.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus will establish reporting mechanisms for information systems and facilities change management to avoid loopholes in security.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus will establish system backup facilities for a periodical update/backup of essential data and software to be able to restore all data immediately during natural damage or storage media failure.\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            Internet Security Management\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus will establish firewalls over our link to monitor data transmission and resource access between the external and the internal network, and will strictly conduct identification operation.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                Confidential and sensitive information or documents regarding the QPlus web site will not be stored in open system nor be delivered by e-mail.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus will periodically examine and inspect internal network for information security purposes, virus code update, and other security measures.\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            System Access Control Management\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus will set up password issuance and change procedures depending on operation system and security management requirement, and will keep a record.\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                The QPlus system management staff will be responsible for granting operation systems account and password according to different authority and making them update regularly.\n                            "
                                )
                              ])
                            ])
                          ]
                        : [
                            _c("h3", { staticClass: "card__subtitle" }, [
                              _vm._v(
                                "\n                            個人資料之蒐集及運用\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                使用中央氣象署「" +
                                    _vm._s(_vm.web_name) +
                                    "」網站時，將自動收集下列資訊：日期和時間、您所擷取之網頁、您所在之網址、您的瀏覽器種類、您對本網站網頁所做行動（如下載等）及成功與否。這些資訊可能被用來改善本網站之效能。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                對本網站造成重大負荷的網址上的行為進行監測。\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "card__subtitle" }, [
                              _vm._v(
                                "\n                            資訊安全權責與教育訓練\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                對處理敏感性、機密性資料之人員及因工作需要須賦於系統管理權限之人員，妥適分工，分散權責並建立評估及考核制度，及視需要建立人員相互支援制度。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                對離（休、停）職人員，依據人員離（休、停）職之處理程序辦理，並立即取消使用各項系統資源所有權限。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                依角色及職能為基礎，針對不同層級人員，視實際需要辦理資訊安全教育訓練及宣導，促使員工瞭解資訊安全的重要性，各種可能的安全風險，以提高員工資訊安全意識，促其遵守資訊安全規定\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "card__subtitle" }, [
                              _vm._v(
                                "\n                            資訊安全作業及保護\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                建立處理資訊安全事件之作業程序，並課予相關人員必要的責任，以便迅速有效處理資訊安全事件。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                建立資訊設施及系統的變更管理通報機制，以免造成系統安全上的漏洞。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                建立系統備援設施，定期執行必要的資料、軟體備份及備援作業，以便發生災害或儲存媒體失效時，可迅速回復正常作業。\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "card__subtitle" }, [
                              _vm._v(
                                "\n                            網路安全管理\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                與外界網路連接之網點，設立防火牆控管外界與內部網路之資料傳輸及資源存取，並執行嚴謹的身分辨識作業。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                機密性及敏感性的資料或文件，不存放在對外開放的資訊系統中，機密性文件不以電子郵件傳送。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                定期對內部網路資訊安全設施與防毒進行查核，並更新防毒系統之病毒碼，及各項安全措施。\n                            "
                                )
                              ])
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "card__subtitle" }, [
                              _vm._v(
                                "\n                            系統存取控制管理\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("ol", [
                              _c("li", [
                                _vm._v(
                                  "\n                                視作業系統及安全管理需求訂定通行密碼核發及變更程序並作成記錄。\n                            "
                                )
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _vm._v(
                                  "\n                                登入各作業系統時，依各級人員執行任務所必要之系統存取權限，由系統管理人員設定賦予權限之帳號與密碼，並定期更新。\n                            "
                                )
                              ])
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.current_about.id === "qplus_4"
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.is_en
                        ? [
                            _c("p", [
                              _vm._v(
                                "\n                            QPlus respects the privacy of every individual who visits our web site: qpeplus.cwa.gov.tw Please review the QPlus Privacy Policy as follows to understand information practices for this site, including what type of information is gathered and tracked, how the information is used, and with whom the information is shared.\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            Personal Data\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            The QPlus may also compile information about you automatically (i.e. not via registration) that is not personally identifiable, including the type of Internet Browser you are using, time spent on a page you are browsing, the IP address of your computer, and the domain name of the web site from which you linked to our site. Such web activity log files will be used to produce statistics to improve the effectiveness of our web site and services. In general, the QPlus will not link this information to other personally identifiable information.\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            Data Employment\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            As for the general information automatically collected and stored about visitors to or users of the QPlus web site, the QPlus will only use it on an aggregate basis, but not individual, to conduct surveys and obtain demographic information for better understanding your needs and improving our services.\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("h6", { staticClass: "content__subtitle" }, [
                              _vm._v(
                                "\n                            Cookies\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            Cookies are tiny text files of messages placed onto the hard drive by a web server for the purpose of identifying user preferences. To track information about visitor's and user's activities at this web site for demographic analysis and for monitoring our site's effectiveness to improve our services, QPlus currently only stores the cookie information to your web browser and makes use of it, in accordance with this policy statement.\n                        "
                              )
                            ])
                          ]
                        : [
                            _c("p", [
                              _vm._v(
                                "\n                            中央氣象署「" +
                                  _vm._s(_vm.web_name) +
                                  "」絕對尊重並保護使用者的個人隱私權。為了幫助您瞭解本網站如何蒐集、應用及保護您所提供的個人資訊，請您詳細閱讀下列隱私權保護政策（Privacy Policy）。\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "card__subtitle" }, [
                              _vm._v(
                                "\n                            個人資料之蒐集政策\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            中央氣象署「" +
                                  _vm._s(_vm.web_name) +
                                  "」會保留您在上網瀏覽或查詢時，伺服器自行產生的相關記錄，包括您使用連線設備的 IP位址、使用時間、使用的瀏覽器、瀏覽及點選資料紀錄等。亦會對個別連線者的瀏覽器予以標示，歸納使用者瀏覽器在中央氣象署「" +
                                  _vm._s(_vm.web_name) +
                                  "」內部所瀏覽的網頁，除非您願意告知您的個人資料，否則本網站不會亦無法將此項記錄和您對應。\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "card__subtitle" }, [
                              _vm._v(
                                "\n                            資料之運用政策\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            對於使用者機器的IP 位址、使用時間、使用的瀏覽器、瀏覽及點選紀錄等資料，中央氣象署「" +
                                  _vm._s(_vm.web_name) +
                                  "」僅對全體使用者行為總和進行分析，並不會對個別使用者進行分析。\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("h3", { staticClass: "card__subtitle" }, [
                              _vm._v(
                                "\n                            Cookies的運用與政策\n                        "
                              )
                            ]),
                            _vm._v(" "),
                            _c("p", [
                              _vm._v(
                                "\n                            Cookies是伺服端為了區別使用者的不同喜好，經由瀏覽器寫入使用者硬碟的一些簡短資訊。為統計瀏覽人數及分析瀏覽模式，以了解網頁瀏覽的情況，做為中央氣象署「" +
                                  _vm._s(_vm.web_name) +
                                  "」改善服務的參考，本系統會在本政策原則之下，在您瀏覽器中寫入並讀取Cookies。\n                        "
                              )
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.current_about.id === "qplus_5"
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.is_en
                        ? [
                            _c("p", [
                              _vm._v(
                                "\n                            Send us your comments, suggestions, or thoughts regarding QPlus. We will respond as soon as possible.\n                            "
                              ),
                              _c("br"),
                              _c("br"),
                              _vm._v("\n                            E-mail："),
                              _c(
                                "a",
                                { attrs: { href: "mailto:qplus@cwa.gov.tw" } },
                                [_vm._v("qplus@cwa.gov.tw")]
                              )
                            ])
                          ]
                        : [
                            _c("p", [
                              _vm._v(
                                "\n                            歡迎您對中央氣象署「" +
                                  _vm._s(_vm.web_name) +
                                  "」的各項功能提供使用建議，請點選【意見信箱】留言，我們在收到您的信件後會立即處理，並於7個工作天內回覆。\n                            "
                              ),
                              _c("br"),
                              _c("br"),
                              _vm._v(
                                "\n                            意見信箱："
                              ),
                              _c(
                                "a",
                                { attrs: { href: "mailto:" + _vm.email } },
                                [_vm._v(_vm._s(_vm.email))]
                              )
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.current_about.id === "qplus_6"
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.is_en
                        ? [
                            _c(
                              "ul",
                              {
                                staticClass: "card__site-map",
                                attrs: { id: "sidemap" }
                              },
                              [
                                _c("li", [
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href:
                                          "https://qpeplus.cwa.gov.tw/pub/about_en/?r=131917?r=106230"
                                      }
                                    },
                                    [_vm._v("Home")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "card__site-map__item" },
                                    [
                                      _c("li", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "https://qpeplus.cwa.gov.tw/pub/"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Map\n                                        "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                "https://qpeplus.cwa.gov.tw/pub/?tab=monitor"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            Monitor  \n                                        "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        : [
                            _c(
                              "ul",
                              {
                                staticClass: "card__site-map",
                                attrs: { id: "sidemap" }
                              },
                              [
                                _c("li", [
                                  _c("a", { attrs: { href: _vm.url_prefix } }, [
                                    _vm._v("首頁")
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "card__site-map__item" },
                                    [
                                      _c("li", [
                                        _c(
                                          "a",
                                          { attrs: { href: _vm.url_prefix } },
                                          [
                                            _vm._v(
                                              "\n                                            電子地圖\n                                        "
                                            )
                                          ]
                                        )
                                      ]),
                                      _vm._v(" "),
                                      !this.is_pub
                                        ? _c("li", [
                                            _c(
                                              "a",
                                              {
                                                attrs: {
                                                  href:
                                                    _vm.url_prefix +
                                                    "?tab=atlas"
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n                                            圖輯\n                                        "
                                                )
                                              ]
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _c("li", [
                                        _c(
                                          "a",
                                          {
                                            attrs: {
                                              href:
                                                _vm.url_prefix + "?tab=monitor"
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n                                            " +
                                                _vm._s(
                                                  this.is_pub ? "觀測" : "監控"
                                                ) +
                                                "\n                                        "
                                            )
                                          ]
                                        )
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.current_about.id === "qplus_7"
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.is_en
                        ? [
                            _c("p", [
                              _vm._v(
                                "\n                            If your browser is IE11 or older, we highly recommend that you upgrade it or switch to Google Chrome, Firefox or Microsoft Edge for best browsing experience.\n                        "
                              )
                            ])
                          ]
                        : [
                            _c("p", [
                              _vm._v(
                                "\n                            如果您使用IE11(含)以下版本瀏覽器，建議您使用其它瀏覽器軟體Google Chrome、Firefox、Microsoft Edge，以獲得最佳瀏覽體驗。使用IE11(含)以下瀏覽器瀏覽本網站，可能部分網頁的呈現會有破圖或版面跑版的情況，某些網頁互動功能無法正確顯示與使用。\n                        "
                              )
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e(),
              _vm._v(" "),
              _vm.current_about.id === "qplus_8"
                ? _c(
                    "div",
                    { staticClass: "content" },
                    [
                      _vm.is_en
                        ? [
                            _c("ol", [
                              _c("li", [
                                _c("h6", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    Which browsers are best suited for viewing the website?\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    We recommend Google Chrome, Firefox, or Microsoft Edge, as they have better compatibility with the QPlus website.\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h6", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    What should I do if the GIS data are not displayed correctly on QPlus website?\n                                "
                                  )
                                ]),
                                _vm._v(
                                  "\n                                If you run into display issues, please first try the following :\n                                "
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        Press “Ctrl+F5” or “Reload.\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        Enter “Control Panel” ->“Network and Internet” -> “Internet Options”, then under the General tab:\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        ･   Go to “Settings”, and choose “Automatically” for “Check for newer versions of stored pages” under “Temporary Internet Files” tab.\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        ･   Click “Delete” to remove temporary Internet files, website file, cookies and website data\n                                    "
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h6", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    Will there be copyright issue if I screenshot or hyperlink the QPlus website?\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    Hyperlink to the site or use of the images are welcome as long as it’s properly credited by indicating “Source: CWA QPlus.\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h6", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    How do I change the account password in a customized version?\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    '\n                                    Please click on "Forgot Password" on the login interface, enter your account and the email address used for registration. A password reset notification will be sent to your email. Click the link in the email to reset your password. Note: The public version does not require an account or password.\n                                '
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h6", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    What do I do when a Forbidden (403) error appears after I log in to the customized unit’s webpage?\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    First, remove the customized unit abbreviation from the end of the URL, and open the public version（"
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "https://qpeplus.cwa.gov.tw/pub"
                                      }
                                    },
                                    [_vm._v("https://qpeplus.cwa.gov.tw/pub")]
                                  ),
                                  _vm._v(
                                    "）.Then change the URL back to the customized unit’s URL, and you should be able to log in.\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h6", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    What if I’m unable to log in when I haven’t forgotten my password or after I’ve reset it?\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    Please click on 【About】 -> 【Contact Us】（"
                                  ),
                                  _c(
                                    "a",
                                    { attrs: { href: "mailto:" + _vm.email } },
                                    [_vm._v(_vm._s(_vm.email))]
                                  ),
                                  _vm._v(
                                    "） to send an email. In your message, provide your account and email used for registration, and describe the issue you are encountering. We will look into it as soon as we receive your email.\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h6", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    How do I change the default time delay in the customized version’s monitoring table?\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    The monitoring table (including weather observations, rainfall observations, rainfall on primary roads, and rainfall on primary bridges) has a default time delay. You can manually select the time in the top-left corner to display the most recent data.\n                                "
                                  )
                                ])
                              ])
                            ])
                          ]
                        : [
                            _c("ol", [
                              _c("li", [
                                _c("h3", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    開啟本網頁有限定使用的瀏覽器嗎？\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    建議您使用Google Chrome、Firefox、Microsoft Edge等瀏覽器軟體，以獲得最佳瀏覽體驗。如果使用IE11(含)以下版本瀏覽器可能部分網頁的呈現會有破圖或版面跑版的情況，某些網頁互動功能無法正確顯示與使用。\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h3", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    畫面圖資未正常顯示，應如何解決？\n                                "
                                  )
                                ]),
                                _vm._v(
                                  "\n                                請以下列方式排除問題 ：\n                                "
                                ),
                                _c("ul", [
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        按【Ctrl】+【F5】或【重新整理】、【重讀】、【Reload】按鍵。\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        按【控制台】->【網際網路選項】->【一般】\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        ･   【設定】->【Temporary Internet Files】-> 檢查儲存的畫面是否有較新的版本-> 點選【每次查閱畫面時】。\n                                    "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c("li", [
                                    _vm._v(
                                      "\n                                        ･   【刪除】-> 清除瀏覽資料，以清除您電腦裡的網頁暫存快取檔案區（Disk Cache）\n                                    "
                                    )
                                  ])
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h3", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    「" +
                                      _vm._s(_vm.web_name) +
                                      "」網頁可供連結或是擷取畫面圖像進行其他形式的應用嗎？\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    歡迎任何網站與本網站連結或使用本網頁圖資，網站連結請標明「圖資來源：中央氣象署劇烈天氣監測系統」；截取網頁圖像於各式媒體或社群網站張貼時請標註「圖像來源：中央氣象署劇烈天氣監測系統」。\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h3", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    客製化版本如何自行修改帳號密碼？\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    請於登入介面點選「忘記密碼」，輸入帳號與註冊時的信箱，即可寄送密碼修改通知信到您的信箱，點擊信件中的連結即可重新設定密碼。 PS：民眾版無需帳號密碼。\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h3", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    客製化單位網頁登入帳號後出現Forbidden (403)如何處理？\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    請先將網址最後一欄客製化單位縮寫拿掉，開啟民眾版（"
                                  ),
                                  _c(
                                    "a",
                                    {
                                      attrs: {
                                        href: "https://qpeplus.cwa.gov.tw/pub"
                                      }
                                    },
                                    [_vm._v("https://qpeplus.cwa.gov.tw/pub")]
                                  ),
                                  _vm._v(
                                    "），再修改網址回到客製化單位的網址後即可成功登入。\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h3", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    帳號密碼無遺忘或修改密碼後仍無法登入？\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    請點選【關於】->【意見信箱】（"
                                  ),
                                  _c(
                                    "a",
                                    { attrs: { href: "mailto:" + _vm.email } },
                                    [_vm._v(_vm._s(_vm.email))]
                                  ),
                                  _vm._v(
                                    "）寄信留言，請在信中提供您的「帳號」與「註冊時的信箱」，並說明您所遇到之問題，我們在收到您的信件後會立即處理。\n                                "
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c("li", [
                                _c("h3", { staticClass: "content__subtitle" }, [
                                  _vm._v(
                                    "\n                                    客製化版本監控表格預設時間延遲處理方法。\n                                "
                                  )
                                ]),
                                _vm._v(" "),
                                _c("p", [
                                  _vm._v(
                                    "\n                                    監控表格(包含地面氣象觀測、雨量觀測、一級監控路段雨量、一級監控橋梁雨量等)預設時間有延遲，可手動選擇左上角時間即可顯示最新資料。\n                                "
                                  )
                                ])
                              ])
                            ])
                          ]
                    ],
                    2
                  )
                : _vm._e()
            ])
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo__text" }, [
      _c("div", { staticClass: "logo__row" }, [
        _c("span", [_vm._v("中")]),
        _vm._v(" "),
        _c("span", [_vm._v("央")]),
        _vm._v(" "),
        _c("span", [_vm._v("氣")]),
        _vm._v(" "),
        _c("span", [_vm._v("象")]),
        _vm._v(" "),
        _c("span", [_vm._v("署")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "logo__text--english logo__row" }, [
        _c("span", [_vm._v("CENTRAL")]),
        _vm._v(" "),
        _c("span", [_vm._v("WEATHER")]),
        _vm._v(" "),
        _c("span", [_vm._v("ADMINISTRATION")])
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }